module.exports = __webpack_public_path__ + "assets/photos/memories/frame-4-mobile--ddd4c95e85c6a9c72086a1817d8e7db7.jpg";